import styled from "styled-components";

export const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

export const Wrapper = styled.section`
    display: flex;
    flex-direction: column;
    padding: 0 40px;

        @media (max-width: 768px) {
        padding: 0 20px 20px;
}
`;

export const Header = styled.h2`
    font-size: 48px;
    text-align: center;
    
    @media (max-width: 768px) {
font-size: 32px;
}
`;

export const SubHeader = styled.h3`
    font-size: 24px;
    text-align: left;
    
        @media (max-width: 768px) {
        font-size: 18px;
}
`;

export const Description = styled.p`
  font-size: 18px;
  line-height: 1.5;
  margin-bottom: 16px;
  text-align: justify;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  margin-bottom: 20px;

  @media (max-width: 768px) {

    thead {
      display: none;
    }

  }
`;

export const TableHeader = styled.th`
  padding: 16px;
  background-color: #93A981;
  font-size: 1.6rem;
  color: white;
`;

export const TableRow = styled.tr`
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  font-size: 1.4rem;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    margin-bottom: 20px;
    border: 2px solid rgb(241, 241, 241);
    border-radius: 10px;
    padding: 15px 10px;
    font-size: 16px;
    box-shadow: 0 0 20px rgba(0,0,0,0.1);
    max-width: 100%;
  }
`;

export const TableCell = styled.td`
  padding: 16px;
  text-align: center;

  svg {
    width: 40px;
    height: 40px;
    vertical-align: middle;
  }

  @media (max-width: 768px) {
    display: block;
    text-align: right;
    position: relative;
    padding-left: 50%;

    &::before {
      content: attr(data-label);
      position: absolute;
      left: 16px;
      width: 45%;
      text-align: left;
      font-weight: bold;
      white-space: nowrap;
    }

    &[data-kind="icon"] {
      order: -1;
      text-align: center;
      padding: 0;

      &::before {
        content: none;
      }
    }

    &[data-kind="type"] {
      padding: 8px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 12px;
      text-align: left;
    }

    &[data-kind="type"]::before {
      position: static;
      width: auto;
      white-space: normal;
      line-height: 1.15;
      flex: 0 0 auto;
    }

    &[data-kind="type"] .cellValue {
      white-space: normal;
      flex: 1 1 auto;
      min-width: 0;
      text-align: right;
    }

    &[data-kind="value"] {
      padding: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 20px;
      text-align: left;
    }

    &[data-kind="value"]::before {
      position: static;
      width: auto;
      white-space: normal;
      line-height: 1.15;
      flex: 1 1 auto;
      min-width: 0;
    }

    &[data-kind="value"] .cellValue {
      white-space: nowrap;
      flex: 0 0 auto;
      text-align: right;
    }
    
    &[data-empty="true"] {
      display: none;

      &::before {
        display: none;
      }
    }
  }
`;

export const Info = styled.div`
  font-size: 18px;
  line-height: 1.5;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const CruiseWrapper = styled.div`
  padding: 20px 20px 0;
  text-align: left;
        @media (max-width: 768px) {
        text-align: center;
  }
`;
export const CruiseSubHeader = styled.h3`
    font-size: 30px;
    text-align: center;
    
        @media (max-width: 768px) {
        font-size: 18px;
        margin: 25px 0;
}
`;

export const ListTitle = styled.h3`
  font-size: 18px;
  font-weight: bold;
  margin: 25px 0;
      @media (max-width: 768px) {
        font-size: 16px;
  }
`;

export const StyledList = styled.ul`
  text-align: left;
  list-style: disc;
  font-size: 18px;
  line-height: 1.5;
  padding-left: 20px;
    @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const ListItem = styled.li`
  margin-bottom: 5px;
`;

export const BoldText = styled.span`
  font-weight: bold;
`;
export const SocialLink = styled.a`
    cursor: pointer;
    font-weight: bold;
    text-decoration: none;
    transition: color 0.3s;
    color: #93A981;

    &:hover {
        color: hsla(93, 30%, 67%, 1.00);
    }
 `;